import React from 'react';
import Title from 'app/components/layout/Title';
import _ from 'lodash';

interface IHeaderThinProps {
  children: React.ReactNode;
  subtitleComponent: React.ReactNode;
  infoText: string;
  title: string;
  subtitle: string;
  breadcrumb: string;
  breadcrumbLink: string;
  divider: boolean;
  isLoading: boolean;
}
export default class HeaderThin extends React.Component<IHeaderThinProps> {
  static defaultProps = {
    children: undefined,
    infoText: '',
    title: '',
    subtitle: '',
    subtitleComponent: undefined,
    breadcrumb: '',
    breadcrumbLink: '',
    divider: false,
    isLoading: false,
  };

  // renderBreadcrumb(): React.ReactNode {
  //   if (!_.isEmpty(this.props.breadcrumb)) {
  //     return (
  //       <Link
  //         to={this.props.breadcrumbLink}
  //         onClick={this.onClick}
  //         className="header-breadcrumb"
  //       >
  //         {this.props.breadcrumb}
  //       </Link>
  //     );
  //   }
  //   return null;
  // }

  renderSubtitle(): React.ReactNode {
    return (
      <div className="row">
        <div className="col">
          <h4 className="subtitle">{this.props.subtitle}</h4>
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="header-thin-container">
        <div className="row">
          <div className="col">
            <Title
              title={this.props.title}
              infoText={this.props.infoText}
              breadcrumb={!_.isEmpty(this.props.breadcrumb)}
              isLoading={this.props.isLoading}
            />
          </div>
          {this.props.children && (this.props.children)}
        </div>
        {!_.isEmpty(this.props.subtitle) && this.renderSubtitle()}
        {!_.isEmpty(this.props.subtitleComponent) && this.props.subtitleComponent}
        {this.props.divider && (
          <div className="row with-margin-top-10">
            <div className="col">
              <div className="divider full less-margin" />
            </div>
          </div>
        )}
      </div>
    );
  }
}
